import type { DestinationStatus } from '../../domain/destinations';

/**
 * Destination status badge metadata — same pattern as Publishing Status: icon + label, semantic colors.
 */
export interface DestinationStatusMeta {
  label: string;
  cssClass: string;
  icon: string;
}

export const DESTINATION_STATUS_META: Record<DestinationStatus, DestinationStatusMeta> = {
  Connected: { label: 'Connected', cssClass: 'status--success', icon: '/assets/icons/success.svg' },
  NeedsReauth: { label: 'Needs re-auth', cssClass: 'status--warning', icon: '/assets/icons/pending.svg' },
  TokenExpired: { label: 'Token expired', cssClass: 'status--warning', icon: '/assets/icons/pending.svg' },
  Disabled: { label: 'Disabled', cssClass: 'status--failed', icon: '/assets/icons/failed.svg' },
};
